import { Box, styled } from '@mui/joy';

export const inlineButtonStyle = {
  padding: '4px',
  minHeight: 'fit-content',
  height: 'fit-content',
};

export const ActionsWrapper = styled(Box)({
  display: 'flex',
  gap: '4px',
  marginTop: '8px',
});

export const NotesMoreWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
});
